import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface WelcomeFeedFilterState {
  /** Категория группировки статусов — фильтр ленты на бэке (GroupingCategoryIds) */
  groupingCategoryId: number | null;
  /** Подпись категории из статистики (для баннера в ленте) */
  categoryLabel: string | null;
}

@Injectable({ providedIn: 'root' })
export class WelcomeActivityFeedFilterService {
  private readonly state$ = new BehaviorSubject<WelcomeFeedFilterState>({
    groupingCategoryId: null,
    categoryLabel: null,
  });

  readonly state = this.state$.asObservable();

  getSnapshot(): WelcomeFeedFilterState {
    return this.state$.value;
  }

  clear(): void {
    this.state$.next({ groupingCategoryId: null, categoryLabel: null });
  }

  /**
   * Клик по строке статистики: фильтр по категории (GroupingCategoryIds на бэке).
   * Повторный клик по той же категории снимает фильтр.
   */
  toggleFromStatRow(categoryLabel: string, groupingCategoryId: number): void {
    if (!(groupingCategoryId > 0)) {
      return;
    }
    const cur = this.state$.value;
    if (cur.groupingCategoryId != null && cur.groupingCategoryId === groupingCategoryId) {
      this.clear();
      return;
    }
    this.state$.next({
      groupingCategoryId,
      categoryLabel,
    });
  }
}
